// dependencies
import { List } from "immutable";
import React from "react";
import { connect } from "react-redux";

import { Spinner } from "@performyard/py-components";

import Button from "../../../../../components/Button";
// components
import Icon from "../../../../../components/Icon";
import Modal from "../../../../../components/Modals/Wrapper";

// containers
import Curtain from "../../../../../containers/PageCurtain";

// actions
import { removeDocumentFromTodo } from "../../actions";

import { getSignatureTemplate, getSignatureTemplateSteps } from "../../../../../selectors/documents";
// selectors
import { getTodoObject } from "../../selectors";

import PropTypes from "../../../../../lib/prop-types";

// utils

export class EditSignatureTemplateComponent extends React.Component {
	static propTypes = {
		removeDocumentFromTodo: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
		hasBeenFetched: PropTypes.bool.isRequired,
		todoID: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		steps: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {};

	handleRemove = () => {
		this.props.removeDocumentFromTodo(this.props.todoID);
	};

	handleClose = () => {
		this.props.onClose();
	};

	render() {
		const { hasBeenFetched, name, steps } = this.props;

		return (
			<Curtain className="curtain-edit-document-signing" color="black" onClose={this.handleClose}>
				<Modal>
					<div className="p-5">
						<div className="text-center text-primary-5">
							<Icon type="fa5" name={["far", "file"]} size="2x" />
						</div>

						{!hasBeenFetched ? (
							<div className="mt-5 flex h-full items-center justify-center">
								<Spinner size={20} />
							</div>
						) : (
							<div>
								<div className="mt-2.5">
									<div className="text-center">{name}</div>
								</div>

								<div className="mx-auto mt-[30px] mb-2.5 h-px w-[200px] bg-neutral-1" />

								<div>
									<div className="py-2.5 text-[15px] font-semibold text-primary-5">
										Signature Steps
									</div>

									{steps.map((step, ii) => {
										const stepKey = `step-${ii}`;

										return (
											<div className="mt-2.5 first:mt-0" key={stepKey}>
												<div className="text-sm leading-5">
													<span className="mr-1.5 font-semibold">{`Signer ${ii + 1}`}</span>{" "}
													{step.get("fields").join(", ")}
												</div>
											</div>
										);
									})}
								</div>

								<div className="mx-auto mt-[30px] mb-2.5 h-px w-[200px] bg-neutral-1" />

								<div className="mt-5 text-center">
									<Button color="red" onClick={this.handleRemove}>
										Remove
									</Button>
									<Button color="transparent" onClick={this.handleClose}>
										Cancel
									</Button>
								</div>
							</div>
						)}
					</div>
				</Modal>
			</Curtain>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const { todoID } = ownProps;
	const todo = getTodoObject(state, todoID);
	const documentID = todo.getIn(["documentSigning", "id"]);

	const signatureTemplate = getSignatureTemplate(state, documentID);

	return {
		hasBeenFetched: signatureTemplate.size > 0,
		id: signatureTemplate.get("id"),
		name: signatureTemplate.get("name", ""),
		documentID: signatureTemplate.get("documentID"),
		steps: getSignatureTemplateSteps(state, documentID),
	};
};

const mapDispatchToProps = (dispatch) => ({
	removeDocumentFromTodo: (todoID) => dispatch(removeDocumentFromTodo(todoID)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditSignatureTemplateComponent);
